import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface TelegramButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "vip";
}

const TELEGRAM_URL = "https://t.me/Roidustreaming";

const TelegramButton = ({
  children,
  className,
  size = "lg",
  variant = "default",
}: TelegramButtonProps) => {
  return (
    <Button
      onClick={() => window.open(TELEGRAM_URL, "_blank", "noopener,noreferrer")}
      className={className}
      size={size}
      variant={variant}
    >
      {children}
    </Button>
  );
};

export default TelegramButton;
